import { getConditionsFilterConfig } from '../filters/condition';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';

export const ukjeShopConfig = {
  ...getDefaultShopConfig(),
  filters: [...custom.filters, getConditionsFilterConfig()],
};
